import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user_cred'));
  if (!user || !user.token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;
